export var PaymentType;
(function (PaymentType) {
    /** Normal payment */
    PaymentType["AR_PAYMENT"] = "ar_payment";
    /** Refunds */
    PaymentType["PREPAYMENT_REFUND"] = "prepayment_refund";
    PaymentType["OVERPAYMENT_REFUND"] = "overpayment_refund";
    PaymentType["CREDIT_NOTE_REFUND"] = "credit_note_refund";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=payment.js.map